import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import proFeaturesData from "../../data/pageSections/home/proFeatures"
import H2 from "../typography/H2"
import P from "../typography/P"
import CardBackground from "./CardBackground"
import Container from "./Container"
import Section from "./Section"
import { redirectUrl } from "../../utils/common"

const ProFeatures = () => {
  const onClick = (url) => {
    if (!url) return
    redirectUrl(url)
  }

  return (
    <Section className="padding-b-30">
      <H2>"Pro" Features Deliver Results</H2>
      <Container className="padding-b-30">
        <ProFeatureCardWrapper>
          {proFeaturesData.map(
            ({ icon, title, description, comingSoon, url, isBeta }) => (
              <ProFeatureCardBackground
                onClick={() => onClick(url)}
                showPointer={url ? true : false}
              >
                {comingSoon && <ComingSoon>Coming</ComingSoon>}
                {isBeta && <ComingSoon>Beta</ComingSoon>}
                <img src={icon} alt={title} title={title} />
                {title}
                <P className="features-description">{description}</P>
              </ProFeatureCardBackground>
            )
          )}
        </ProFeatureCardWrapper>
      </Container>
      <CustomContainer>
        <P style={{ textAlign: "right", width: "100%" }}>
          <i>Some features available on specific plans</i>
        </P>
      </CustomContainer>
    </Section>
  )
}

export default ProFeatures

const ComingSoon = styled(P)`
  background-color: #bc5de8;
  color: #fff;
  padding: 5px 15px;
  border-radius: 100px;
  margin-bottom: 0;
  position: absolute;
  top: 8px;
  right: 8px;
  font-size: 14px;
  ${({ theme }) => theme.desktop`
  font-size: 14px;
  `}
`

const ProFeatureCardWrapper = styled.div`
  ${({ theme }) => theme.se`
   display: flex;
   flex-direction: column;
   position: relative;
  `}
  ${({ theme }) => theme.tablet`
   flex-direction: row;
   flex-wrap: wrap;
   justify-content: space-around;
  `}

  ${({ theme }) => theme.desktop`
   
  `}
`

const ProFeatureCardBackground = styled(CardBackground)`
  cursor: ${(props) => (props.showPointer ? "pointer" : "default")};

  padding: 50px 25px;

  ${({ theme }) => theme.se`
    // :first-child, :nth-child(2) {
    // margin-bottom: 100px;
    // }
    padding: 50px 20px;
    padding-bottom: 0px;
    
    margin-bottom: 30px;

    img {
      height: 90px;
    }
  `}
  ${({ theme }) => theme.desktop`
    width: 23%;
    margin: 0 auto;
    margin-bottom: 30px;
    min-height: 450px;
  `}
`

const CustomContainer = styled(Container)`
  ${({ theme }) => theme.se`
   padding-top: 0px;
   padding-bottom: 0px;
   `}
`
